import React from "react"
import Back from "../common/back/Back"
import BlogCard from "./BlogCard"
import SEO from "../common/SEO"
import "./blog.css"

const Blog = () => {
  return (
    <>
      <SEO 
        title="Blog - Education Insights & Updates"
        description="Stay updated with the latest education news, study abroad tips, visa updates, and expert insights from WELSH EDUCATION GROUP. Read our informative blog posts."
        keywords="education blog, study abroad tips, visa updates, education news, international education blog"
        url="/journal"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "WELSH EDUCATION GROUP Blog",
          "description": "Education insights and updates",
          "url": "https://welsheducation.com/journal",
          "publisher": {
            "@type": "EducationalOrganization",
            "name": "WELSH EDUCATION GROUP"
          }
        }}
      />
      <Back title='Blog Posts' />
      <section className='blog padding'>
        <div className='container grid2'>
          <BlogCard />
        </div>
      </section>
    </>
  )
}

export default Blog
